import { FlightSearchFormData, formDataToQueryParams } from '@reward-platform/flights-schemas'
import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { useFlightSearchFormData } from '~/components/search-and-results/SearchFlightForm/hooks/useFlightSearchFormData'
import { useAccount } from '~/context/account'
import { useUser } from '~/context/user'
import { useNavigationAnalytics } from '~/hooks/useNavigationAnalytics'
import { flightPageDetails } from '~/utils/googleTagManager/googleTagManagerHelperFunctions'
import { SearchFlightForm, type DatePickerControlRequest } from './SearchFlightForm'

type Props = {
  onSubmit?: (formData: Readonly<FlightSearchFormData>) => void
  datePickerControlRequest?: DatePickerControlRequest | null
  destinationFocusRequest?: number | null
}

export function SearchFlightFormWrapper({
  onSubmit,
  datePickerControlRequest,
  destinationFocusRequest,
}: Readonly<Props>) {
  const { onNavigate } = useNavigationAnalytics()
  const router = useRouter()
  const userContext = useUser()
  const { aviosBalance } = useAccount()
  const { formData } = useFlightSearchFormData()

  const onSearchFormSubmit = useCallback(
    (data: FlightSearchFormData) => {
      onNavigate({
        navType: 'cta',
        navAction: 'search flights',
        extra: { event: 'navigation', ...flightPageDetails(router, userContext, aviosBalance) },
      })

      const queryData = formDataToQueryParams(data)

      const params = new URLSearchParams()
      Object.entries(queryData).forEach(([key, value]) => {
        if (value !== undefined) {
          params.set(key, String(value))
        }
      })

      // eslint-disable-next-line no-void
      void router.push({ pathname: 'flights/results', query: params.toString() })
    },
    [router, onNavigate, userContext, aviosBalance]
  )

  return (
    <SearchFlightForm
      onValidSubmit={onSubmit ?? onSearchFormSubmit}
      formData={formData}
      datePickerControlRequest={datePickerControlRequest}
      destinationFocusRequest={destinationFocusRequest}
    />
  )
}
